
import EnumSelect from '../../../types/global.d';
import { t } from "@lingui/core/macro";

export enum ShipmentType {
    Logs = "Logs",Cordwood = "Cordwood",
}

export enum ShipmentTypeDisplay {
    Logs = "Logs",Cordwood = "Cordwood",
}

export const ShipmentTypePairs = Object.keys(ShipmentType)
  .map(key=> ({id: key, name: ShipmentType[key]}));

export function toString(value?: EnumSelect): string {
  return value ? ShipmentType[value.id] : '';
}

export function toStringDisplay(value?: string): string | undefined {
    switch (value) {
            
        case ShipmentTypeDisplay.Logs:
            return t`Logs`;
            
        case ShipmentTypeDisplay.Cordwood:
            return t`Cordwood`;
            
        default:
            return undefined;
    }
}
